import React, { FC, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import TableTab from "../../../components/tabs/table-tab";
import { REPORTS_ENROLMENTS } from "../../../constants/menu-types";
import { useLocale } from "../../../contexts/localeContext";
import { TableContextProvider } from "../../../contexts/table/TableContextProvider";
import { TranslationKeys } from "../../../contexts/TranslationKeys";
import EnrolmentColumns from "../../../models/ColumnDefinitions/EnrolmentColumns";
import { Lookup } from "../../../models/Lookup";
import LookupTypes from "../../../models/LookupTypes";
import CompanySearch from "../../../models/search/CompanySearch";
import DepartmentSearch from "../../../models/search/DepartmentSearch";
import EnrolmentSearch from "../../../models/search/EnrolmentSearch";
import SiteSearch from "../../../models/search/SiteSearch";
import { getCompanyNamesWithPagination } from "../../../services/companyService";
import { getDepartmentNamesWithPagination } from "../../../services/departmentService";
import { getSiteNamesWithPagination } from "../../../services/siteService";
import { getCategoryNameWithPagination } from "../../../services/categoryService";
import CategorySearch from "../../../models/search/CategorySearch";
import { getEnrolments } from "../../../services/enrolmentService";
import { getErrorMessage } from "../../../services/utilities/ServiceError";

interface EnrolmentReportProps {
    reportId: string;
}

const EnrolmentsReport: FC<EnrolmentReportProps> = ({ reportId }) => {
    const { translate } = useLocale();
    const [lookup, setLookup] = useState<Lookup[]>([]);

    useEffect(() => {
        setLookup([
            {
                name: LookupTypes.company,
                values: [],
                dataMethod: getCompanyNamesWithPagination,
                searchAccessor: CompanySearch.find(item => item.accessor === "name")?.searchOnName
            },
            {
                name: LookupTypes.department,
                values: [],
                dataMethod: getDepartmentNamesWithPagination,
                searchAccessor: DepartmentSearch.find(item => item.accessor === "name")?.searchOnName
            },
            {
                name: LookupTypes.site,
                values: [],
                dataMethod: getSiteNamesWithPagination,
                searchAccessor: SiteSearch.find(item => item.accessor === "name")?.searchOnName
            },
            {
                name: LookupTypes.profile_id,
                values: [],
                dataMethod: getCategoryNameWithPagination,
                searchAccessor: CategorySearch.find(item => item.accessor === "name")?.searchOnName
            }
        ]);
    }, [])

    // user preference items
    const userLoginId = useSelector((state: any) => (state.userInfo.id))
    const currentMenuDetail = REPORTS_ENROLMENTS;
    const initialiseUserPreferences = (setDetails: (userLoginId, currentMenuDetail, [], reportId) => void) => {
        setDetails(userLoginId, currentMenuDetail, [], reportId);
    }
    // <-- end context

    const getDataMethod = async (listParameters?: any) => {
        try {
            return getEnrolments(translate, listParameters);
        } catch (error) {
            return Promise.reject(getErrorMessage(error));
        }
    }

    return (<TableContextProvider
        dataMethod={getDataMethod}
        initialiser={(setDetails) => initialiseUserPreferences(setDetails)}
        tableDescriptor={EnrolmentColumns}
        searchDescriptor={EnrolmentSearch}
        useFilter
        useSort
        usePagination
        useSearch
        useTable
        lookup={lookup}>
        <TableTab
            title={''}
            reportTitle={translate.byKey(TranslationKeys.enrolments)}
            selectRows={false}
            cyName="EnrolmentReport">
        </TableTab>
    </TableContextProvider >
    );
};

export default EnrolmentsReport;
